/* eslint-disable */
jQuery(function($) {

    function copyToClipboard(element) {

        var $temp = $("<input>");

        $("body").append($temp);

        $temp.val($(element).data('clipboard-text')).select();

        $('#generated-btn span').html('Copiado');
        $('#generated-btn').addClass('copy-pix--copied');

        setTimeout(() => {
            $('#generated-btn span').html('Copiar código PIX').removeClass('copy-pix--copied');
            $('#generated-btn').removeClass('copy-pix--copied');
          }, "2000")

        document.execCommand("copy");

        $temp.remove();

    }


    $(document).on('click', '#generated-btn', function() {
        copyToClipboard('#generated-btn')
    })

});
